import * as React from "react";
import * as S from "@styled";
import * as CleanOldVersionActions from "../../actions/CleanOldVersionsActions";
import CustomModal from "shared/components/CustomModal";
import { State } from "processList/model/State";
import { connect } from "react-redux";
import { DispatchType, Utilities } from "shared/utilities";
import Select from "shared/components/select/Select";
import { Option } from "shared/model/Option";
import { SingleValue } from "react-select";
import { DeletableProcessVersions } from "processList/model/CleanOldVersionsDialogState";

const CleanOldVersionsDialog: React.FC<CleanOldVersionsDialogProps> = (props) => {

    const handleCleanup = () => {
        if (!Object.keys(props.processesMarkedForDeletion).length) {
            Utilities.toastError("Choose Process versions for deletion");
            return;
        }
        if (confirm("Are you sure you want to delete the Process version and the versions before? This action can't be reverted.")) {
            const processId = Object.values(props.processesMarkedForDeletion)[0]
            props.onCleanup(processId);
        }
    }

    const handleMarkProcessVersionForDeletion = (option: SingleValue<Option<number>>, processName: string) => {
        if (option) {
            props.onSetProcessesMarkedForDeletion(option.value, processName)
        }
    }

    if (!props.showDialog) {
        return null;
    }

    return (
        <CustomModal
            label="clean-old-versions-dialog"
            onClose={props.onClose}
            shouldCloseOnOverlayClick={true}
            show={true}
            size="medium"
            modalTitle={<h2>{FRENDS.Localizations.Cleanup} old versions</h2>}
        >
            {!Object.keys(props.deletableProcessVersions).length ? (
                <h3>No Process versions to cleanup</h3>
            ) : (
                <>
                    <S.WarningContainer>
                        <div className="alert-warning">
                            <div className="alert-label">{FRENDS.Localizations.Warning}</div>
                            <div className="alert-content">The selected version and the versions before will be deleted. This action can not be reverted.</div>
                            <div className="alert-content">
                                The following actions will be taken:
                                <p>- Process versions will be deleted</p>
                                <p>- API Process links will be deleted</p>
                                <span>- Process will be deleted from the nuget repository</span>
                            </div>
                        </div>
                    </S.WarningContainer>
                    {Object.entries(props.deletableProcessVersions).map(([processName, deletableVersions]) => {
                        const options: Option<number>[] = Object.entries(deletableVersions).map(([processVersion, processId]): Option => ({ value: processId, label: processVersion.toString() }));
                        const selectId = props.processesMarkedForDeletion[processName];
                        return (
                            <S.FormGroup key={processName} $inline={true}>
                                <S.Label>{processName}</S.Label>
                                <Select
                                    options={options}
                                    className="cleanup-process-version-selector"
                                    classNamePrefix="react-select"
                                    value={Utilities.valueFromId(options, selectId)}
                                    placeholder={"Select Process version for deletion"}
                                    onChange={(option) => handleMarkProcessVersionForDeletion(option, processName)}
                                    menuPlacement="auto"
                                    menuPortalTarget={document.body}
                                />
                            </S.FormGroup>
                        )
                    })}
                    <S.FormGroup>
                        <S.ButtonGroup $justifyContentEnd={true} gap={10}>
                            <S.Button variant={S.ButtonType.bordered} onClick={props.onClose}>{FRENDS.Localizations.Cancel}</S.Button>
                            <S.Button onClick={handleCleanup}>{FRENDS.Localizations.Cleanup}</S.Button>
                        </S.ButtonGroup>
                    </S.FormGroup>
                </>
            )}
        </CustomModal>
    )
}


interface CleanOldVersionsDialogStateProps {
    showDialog: boolean;
    processGuid: string;
    deletableProcessVersions: DeletableProcessVersions;
    processesMarkedForDeletion: Record<string, number>;
}

interface CleanOldVersionsDialogDispatchProps {
    onClose: () => void;
    onCleanup: (processId: number) => void;
    onSetProcessesMarkedForDeletion: (newValue: number, processName: string) => void;
}

export type CleanOldVersionsDialogProps = CleanOldVersionsDialogStateProps & CleanOldVersionsDialogDispatchProps;
const mapStateToProps = (state: State): CleanOldVersionsDialogStateProps => {
    return {
        showDialog: state.cleanOldVersionsDialogState.showDialog,
        processGuid: state.cleanOldVersionsDialogState.processGuid,
        deletableProcessVersions: state.cleanOldVersionsDialogState.deletableProcessVersions,
        processesMarkedForDeletion: state.cleanOldVersionsDialogState.processesMarkedForDeletion
    };
};

const mapDispatchToProps = (dispatch: DispatchType<State>): CleanOldVersionsDialogDispatchProps => {
    return {
        onSetProcessesMarkedForDeletion: (newValue, processName) => dispatch(CleanOldVersionActions.onSetProcessesMarkedForDeletion(newValue, processName)),
        onClose: () => dispatch(CleanOldVersionActions.closeCleanVersionsDialog()),
        onCleanup: (processId) => dispatch(CleanOldVersionActions.cleanUpVersions(processId))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CleanOldVersionsDialog);
